<div class="reporting-container" fxFill>
    <router-outlet></router-outlet>
</div>

